import React from "react";
import { Box, Typography } from "@mui/material";
import { SERVICE_STATUS } from "../constants";
import { C } from "../theme";

function KPI({ label, value }) {
  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        border: `1px solid ${C.border}`,
        borderRadius: 2,
        bgcolor: "#fff",
        minWidth: 110,
        flex: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: C.textSoft,
          textTransform: "uppercase",
          letterSpacing: 0.4,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          mt: 0.5,
          fontSize: 24,
          fontWeight: 700,
          color: C.text,
          lineHeight: 1,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default function ServiceKPIs({ servicios = [] }) {
  const total = servicios.length;
  const pending = servicios.filter((s) => s.status === SERVICE_STATUS.PENDING).length;
  const scheduled = servicios.filter((s) => s.status === SERVICE_STATUS.SCHEDULED).length;
  const completed = servicios.filter((s) => s.status === SERVICE_STATUS.COMPLETED).length;

  return (
    <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
      <KPI label="Total mes" value={total} />
      <KPI label="Pendientes" value={pending} />
      <KPI label="Programados" value={scheduled} />
      <KPI label="Completados" value={completed} />
    </Box>
  );
}